<template>

  <div class="widget-content-product" :class="{ 'image-only': isImageOnly }" v-if="product">
    <div class="product-image" v-if="settings.showImage && imageAsset" v-background-image="imageAsset.url"></div>
    <div class="title" v-if="settings.showTitle || settings.showSubtitle">
      <div class="title-inner">

        <dmb-widget-styled-text v-if="settings.showTitle" :style="settings.titleTextStyle">{{
            product.title
          }}
        </dmb-widget-styled-text>
        <div class="allergy-icons">
          <dmb-asset v-if="product.glutenfree" :asset-id="showStyle.glutenfreeAssetId" stuffed></dmb-asset>
          <dmb-asset v-if="product.veggie" :asset-id="showStyle.veggieAssetId" stuffed></dmb-asset>
        </div>
      </div>
      <dmb-widget-styled-text v-if="settings.showSubtitle && product.subtitle" :style="settings.subtitleTextStyle">
        {{ product.subtitle }}
      </dmb-widget-styled-text>
    </div>

    <div class="price" v-for="priceOption in prices" v-if="settings.showPrice || settings.showVariant">
      <dmb-widget-styled-text v-if="settings.showVariant" :style="settings.variantTextStyle">
        {{ priceOption.variant.title }}
      </dmb-widget-styled-text>
      <dmb-widget-styled-text class="price-value" v-if="settings.showPrice" :style="settings.priceTextStyle">
        <dmb-price :currency="settings.showCurrency" :mode="settings.priceMode" :price="priceOption.price"/>
      </dmb-widget-styled-text>
    </div>
  </div>
  <div v-else-if="freeze" class="widget-content-placeholder">{{
      $t('app.widgets.widgetContentProduct.noProduct')
    }}
  </div>

</template>

<script>

import {Vue, Options} from 'vue-class-component'
import {sortBy} from 'lodash';

import WidgetStyledText from '../WidgetStyledText.vue';
import Price from '../Price.vue';

import ProductState from '../../enum/ProductState';
import Asset from "../ui/Asset.vue";

export default Options({
  name: 'dmb-widget-content-product',
  components: {
    [WidgetStyledText.name]: WidgetStyledText,
    [Asset.name]: Asset,
    [Price.name]: Price,
  },
  props: {
    widget: Object,
    freeze: Boolean
  }
})(
    class WidgetContentProduct extends Vue {

      get settings() {

        return this.widget.settings;
      }

      get product() {

        const product = this.$store.getters.getProduct(this.widget.settings.productId);
        if (!product) {
          return null;
        }

        if (!this.freeze && product.state !== ProductState.AVAILABLE) {
          return null;
        }

        console.log(product)
        return product;
      }

      get imageAsset() {

        console.log(this.$store.getters.getAsset(this.product.imageAssetId))
        return this.product.imageAssetId ? this.$store.getters.getAsset(this.product.imageAssetId) : null;
      }

      get prices() {

        if (!this.product) {
          return [];
        }

        if (this.settings.variantId) {
          return this.product.prices.filter(price => price.variantId.toString() === this.settings.variantId.toString());
        } else {
          return sortBy(this.product.prices, 'variant.sortIndex');
        }
      }

      get showStyle() {

        return this.$store.state.style.showStyle;
      }

      get isImageOnly() {

        const st = this.settings;
        return st.showImage && !st.showTitle && !st.showSubtitle && !st.showPrice && !st.showVariant;
      }
    }
)

</script>
<style src="../../../scss/component/widget/WidgetContentProduct.scss" lang="scss"></style>
